import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 71;
  return <section className="w-full bg-[#FBF5EC] donut-pattern py-4 md:py-8" data-id="element-162">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-164">
          <div className="text-center mb-3 md:mb-5" data-id="element-165">
            <div className="bg-[#FDF2EC] border border-[#E5C9B0] rounded-2xl p-4 md:p-6 max-w-3xl mx-auto shadow-sm" data-id="element-166">
              <h2 className="text-2xl md:text-4xl font-bold text-[#3D2817] mb-3 md:mb-4" data-id="element-167">
                ⏰ PRECIO DE LANZAMIENTO — OFERTA LIMITADA
              </h2>

              <div className="flex items-center justify-center gap-2 md:gap-4 mb-3 md:mb-4" data-id="element-168">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-169">
                    {index > 0 && <span className="text-4xl md:text-7xl font-bold text-[#B85450] -mt-4 md:-mt-6" data-id="element-170">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-171">
                      <motion.span key={unit.value} initial={{
                    scale: 1.1,
                    opacity: 0.7
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.2
                  }} className="text-5xl md:text-8xl font-bold text-[#B85450] tabular-nums leading-none" data-id="element-172">
                        {unit.value}
                      </motion.span>
                      <span className="text-xs md:text-sm text-[#9B8770] font-medium mt-1 tracking-widest" data-id="element-173">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              <div className="flex items-center justify-center gap-2 text-[#3D2817] mb-3 md:mb-4" data-id="element-174">
                <span className="text-lg md:text-xl" data-id="element-175">⚠️</span>
                <p className="text-sm md:text-base font-semibold" data-id="element-176">
                  Este precio no se va a mantener. Una vez que se agoten los
                  cupos de lanzamiento, el precio sube a $58.960 ARS. No vuelve
                  atrás.
                </p>
              </div>

              <div className="max-w-xl mx-auto" data-id="element-177">
                <div className="flex items-center justify-between mb-1" data-id="element-178">
                  <div className="flex items-center gap-2" data-id="element-179">
                    <span className="w-2 h-2 rounded-full bg-[#B85450] animate-pulse" data-id="element-180"></span>
                    <span className="text-sm text-[#B85450] font-medium" data-id="element-181">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-sm text-[#6B5747] font-bold" data-id="element-182">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-3 bg-[#F0E3CE] rounded-full overflow-hidden" data-id="element-183">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full" style={{
                  background: 'linear-gradient(90deg, #B85450 0%, #B45309 70%, #D4A373 100%)'
                }} data-id="element-184" />
                </div>
                <p className="text-xs text-[#9B8770] mt-1 text-right" data-id="element-185">
                  {cuposPercentage}% de los cupos ya tomados
                </p>
              </div>
            </div>
          </div>

          <h3 id="elegi-tu-pack" className="text-2xl md:text-3xl font-bold text-[#3D2817] text-center mb-3 md:mb-5 scroll-mt-8" data-id="element-186">
            TU ACCESO COMPLETO
          </h3>

          <div className="max-w-2xl mx-auto" data-id="element-187">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-gradient-to-b from-white to-[#FBF5EC] border-2 border-[#B8855C] rounded-lg p-5 md:p-6 relative shadow-md" data-id="element-188">
              <h4 className="text-xl font-bold text-[#3D2817] mb-1" data-id="element-189">
                🍩 MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-[#B45309] font-semibold mb-2 text-sm" data-id="element-190">
                6 Tomos + 4 Bonos — Masa → Negocio en Pesos
              </p>
              <p className="text-[#6B5747] text-sm mb-3" data-id="element-191">
                Ideal para cualquier persona que quiera emprender con minidonas
                desde casa, sin experiencia previa
              </p>
              <div className="mb-3" data-id="element-192">
                <div className="flex items-center gap-2 mb-1" data-id="element-193">
                  <span className="text-[#9B8770] line-through text-xl font-medium" data-id="element-194">
                    $58.960
                  </span>
                  <span className="bg-[#B85450] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-195">
                    -71% OFF
                  </span>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-196">
                  <span className="text-[#B45309] font-bold text-4xl md:text-5xl" data-id="element-197">
                    $16.990
                  </span>
                  <span className="text-[#9B8770] text-sm" data-id="element-198">ARS</span>
                </div>
                <p className="text-[#5C8A6D] font-semibold text-sm mt-1" data-id="element-199">
                  ✅ Ahorrás $41.970 hoy
                </p>
              </div>
              <motion.a id="boton-pago" href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-[#B45309] hover:bg-[#92400E] text-white font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-lg shadow-[#7A4A2B]/30 text-center scroll-mt-24" data-id="element-200">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>

              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Quiero%20abonar%20el%20Mega%20Pack%20Emprende%20Minidonas%20360%20con%20transferencia%20bancaria%20y%20aprovechar%20el%2015%25%20de%20descuento.%20Gracias!!" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="mt-2 flex items-center justify-center gap-2 w-full bg-white hover:bg-[#F0FAF3] border-2 border-[#25D366] text-[#1ebe5b] font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors text-center" data-id="element-201">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-202">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-203" />
                </svg>
                💸 Pagar por transferencia — 15% OFF ($14.441)
              </motion.a>

              <div className="mt-2 text-center text-xs text-[#9B8770]" data-id="element-204">
                ⭐ Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
                <br data-id="element-205" />
                Mercado Pago · Tarjeta · Transferencia
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}